import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'Usá nombres cortos y descriptivos: "Excavadoras", "Camiones", "Montacargas".',
    'Las familias agrupan equipos del mismo tipo; son la base para armar plantillas de Check List.',
    'Una familia bien definida facilita los reportes y la búsqueda de equipos.',
  ],
  nextSteps: [
    'Configurar Tipos de Equipo para mayor detalle de clasificación.',
    'Crear plantillas de Check List asociadas a cada familia.',
    'Dar de alta equipos y asignarles su familia correspondiente.',
  ],
};

const ConfiguracionFamilias = () => (
  <ConfiguracionBase
    apiEndpoint="familias"
    titulo="Familias"
    descripcion="Clasificación de equipos por familia"
    icon="fas fa-layer-group"
    compact
    help={HELP}
  />
);

export default ConfiguracionFamilias;